var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.rows && _vm.rows.length)?_c('span',_vm._l((_vm.rows),function(row){return _c('span',{key:row,staticClass:"taggle"},[_vm._v(_vm._s(row))])}),0):_c('span',{staticClass:"taggle"},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }